/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_6_TitleInputs */

const en_vc_ft_6_title = /** @type {(inputs: Vc_Ft_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimension tool`)
};

const zh_vc_ft_6_title = /** @type {(inputs: Vc_Ft_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尺寸标注工具`)
};

/**
* | output |
* | --- |
* | "Dimension tool" |
*
* @param {Vc_Ft_6_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_6_title = /** @type {((inputs?: Vc_Ft_6_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_6_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_6_title(inputs)
	return zh_vc_ft_6_title(inputs)
});
export { vc_ft_6_title as "vc.ft.6.title" }